export default __webpack_public_path__ + "static/media/Insta.5d3f134b.svg";